// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".App {\n    text-align: center;\n  }\n  \n  .App-logo {\n    height: 40vmin;\n    pointer-events: none;\n  }\n  \n  @media screen and (max-width: 768px) {\n    #codeificare-logo {\n      width: 300px;\n    }\n  }\n  \n  .App-link {\n    color: #61dafb;\n  }\n", ""]);
// Exports
module.exports = exports;
